<template>
    <div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>{{$t('i18n.apk_mange')}}</el-breadcrumb-item>
            <el-breadcrumb-item>{{$t('i18n.gray_test')}}</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="app-container">
            <el-card class="filter-container" shadow="never">
                <div>

                    <!-- <el-select  style="padding-left:10px" v-model="queryInfo.projectName"      placeholder="选择APK"      :filterable="true"      clearable @change="handleSelectionChange"  >
                       <el-option      v-for="item in apkList"      :key="item.value"      :label="item.label"      :value="item.label"  ></el-option>
                    </el-select> -->
                    <span style="padding-left:20px">
                        <el-col :span="3">
                            <el-input :placeholder="$t('i18n.column.name_search')" v-model="queryInfo.apkName" @keyup.enter.native="apkInnerTestList" clearable @clear="apkInnerTestList">
                                <el-button slot="append" icon="el-icon-search" @click="apkInnerTestList"></el-button>
                            </el-input>
                        </el-col>
                        <el-col :span="3">
                            <el-input :placeholder="$t('i18n.column.imei_search')" v-model="queryInfo.imei" @keyup.enter.native="apkInnerTestList" clearable @clear="apkInnerTestList">
                                <el-button slot="append" icon="el-icon-search" @click="apkInnerTestList"></el-button>
                            </el-input>
                        </el-col>
                        <el-button type="primary" round @click="addDialogVisible=true" size="mini">{{$t('i18n.batch_import_imei')}}</el-button>
                    </span>
                </div>

            </el-card>

            <!-- 指定APK添加IMEI的对话框 -->
            <el-dialog :title="$t('i18n.add_imei')" :visible.sync="addDialogVisible" width="50%" @close="addDialogClose">
                <!-- 内容主体区域 -->
                <el-form :model="addForm" :rules="addFormRules" ref="addFormRef" label-width="70px">
                    <el-form-item :label="$t('i18n.choose_app')" label-width="120px" prop="apkId">
                        <el-select v-model="addForm.apkId" :placeholder="$t('i18n.choose_app')" filterable style="width: 100%">
                            <el-option v-for="item in apkList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="IMEI" prop="imeiList" label-width="120px">
                        <el-input v-model="addForm.imeiList" :placeholder="$t('i18n.imei_add_tip')"></el-input>
                    </el-form-item>
                </el-form>
                <!-- 底部区域 -->
                <span slot="footer" class="dialog-footer">
                    <el-button @click="addDialogVisible = false">{{$t('i18n.cancel')}}</el-button>
                    <el-button type="primary" @click="addImei">{{$t('i18n.confirm')}}</el-button>
                </span>
            </el-dialog>

        </div>

        <div class="table-container">
            <!-- table表格区域 -->
            <el-table :data="imeiList" border stripe>
                <el-table-column label="ID" width="80px" prop="id"></el-table-column>
                <el-table-column :label="$t('i18n.column.app_name')" prop="apkName"></el-table-column>
                <el-table-column :label="$t('i18n.column.app_code')" prop="apkCode"></el-table-column>
                <el-table-column label="IMEI" prop="imei" width="330px"></el-table-column>
                <el-table-column :label="$t('i18n.column.create_time')" prop="createTime"></el-table-column>
                <el-table-column :label="$t('i18n.column.is_enabled')" prop="useFlag">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.useFlag" :active-value="1" :inactive-value="0" @change="handleUpdateStatus(scope.row)"></el-switch>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('i18n.column.operator')" width="260px">
                    <template slot-scope="scope">
                        <el-button type="danger" circle icon="el-icon-delete" size="mini" @click="apkInnerTestDelete(scope.row)">
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="paginnation-container">
            <!-- 分页区域 -->
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.pageNo" :page-sizes="[5, 10, 15, 20]" :page-size="queryInfo.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalSize" background></el-pagination>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

const defaultListQuery = {
    apkName: '',
    imei: '',
    pageNo: 1,
    pageSize: 15
};

export default {
    data() {
        return {
            // 查询参数对象
            // APK列表
            imeiList: [],
            apkList: [],
            // 总数据条数
            totalSize: 0,
            queryInfo: Object.assign({}, defaultListQuery),
            // 控制添加APK对话框的显示与隐藏
            addDialogVisible: false,
            // 添加APK的表单数据
            addForm: {
                apkId: '',
                imeiList: null
            },
            // 添加表单的验证规则对象
            addFormRules: {
                apkId: [{ required: true, message: this.$t('i18n.validate.app_need'), trigger: 'blur' }],
                imeiList: [{ required: true, message: this.$t('i18n.validate.iemi_need'), trigger: 'blur' }]
            }
        };
    },
    created() {
        this.getApkList();
        this.apkInnerTestList();
        this.sessionKey = localStorage.getItem('sessionKey');
    },
    methods: {
        apkInnerTestList() {
            this.$http
                .get('/apk/apkInnerTestQueryPage', {
                    params: this.queryInfo
                })
                .then(res => {
                    res = res.data;
                    // console.log('测试IMEI返回', res);
                    if (res.code !== 0) {
                        return this.$message.error(res.msg);
                    }
                    this.imeiList = res.data.list;
                    this.totalSize = res.data.totalSize;
                });
        },
        handleSelectionChange() {
            this.apkInnerTestList();
        },
        // 根据分页获取对应的APK列表
        getApkList() {
            this.$http
                .get('/apk/apkInfoQueryAll')
                .then(res => {
                    res = res.data;
                    if (res.code !== 0) {
                        return this.$message.error(res.msg);
                    }
                    // this.apkList = [];
                    let apkList = res.data;
                    for (let i = 0; i < apkList.length; i++) {
                        this.apkList.push({ label: apkList[i].apkName, value: apkList[i].id });
                    }
                });
        },

        handleSizeChange(newSize) {
            this.queryInfo.pageSize = newSize;
            this.apkInnerTestList();
        },
        handleCurrentChange(newPage) {
            this.queryInfo.pageNo = newPage;
            this.apkInnerTestList();
        },
        async apkInnerTestDelete(row) {
            console.log('----当前------', row);
            const confirmResult = await this.$confirm(this.$t('i18n.is_delete_continue'), this.$t('i18n.tip'), {
                confirmButtonText: this.$t('i18n.confirm'),
                cancelButtonText: this.$t('i18n.cancel'),
                type: 'warning'
            }).catch(err => {
                console.log('删除测试IMEI', err);
                return err;
            });

            if (confirmResult !== 'confirm') {
                return this.$message.info(this.$t('i18n.had_cancel_delete'));
            }
            const { data: res } = await this.$http.post('apk/apkInnerTestDelete?id=' + row.id);
            if (res.code !== 0) {
                return this.$message.error(res.msg);
            }
            this.$message.success(this.$t('i18n.success'));
            this.apkInnerTestList();
        },

        async handleUpdateStatus(row) {
            const { data: res } = await this.$http.post('apk/apkInnerTestUpdateUseFlag', {
                id: row.id,
                useFlag: row.useFlag
            });
            if (res.code != 0) {
                if (row.status === 0) {
                    row.status = 1;
                } else {
                    row.status = 0;
                }
                return this.$message.error(res.msg);
            }
        },

        // 监听添加IEMI对话框的关闭事件
        addDialogClose() {
            this.$refs.addFormRef.resetFields();
        },
        // 监听添加IEMI对话框的关闭事件
        delDialogClose() {
            this.$refs.delFormRef.resetFields();
        },

        // 监听添加IEMI对话框的关闭事件
        importDialogClose() {
            this.$refs.importFormRef.resetFields();
        },
        // 点击按钮，添加新IEMI
        addImei() {
            this.$refs.addFormRef.validate(async valid => {
                if (!valid) return;
                // 可以发起添加IMEI的网络请求
                this.addForm.imeiList = this.addForm.imeiList.split(',');
                const { data: res } = await this.$http.post('/apk/apkInnerTestAdd', this.addForm);
                if (res.code !== 0) {
                    this.$message.error(res.msg);
                }
                // 隐藏添加IEMI的对话框
                this.addDialogVisible = false;
                // 重新获取IEMI列表数据
                this.apkInnerTestList();
            });
        }
    }
};
</script>


<style  scoped>
.el-pagination {
    text-align: right;
}
</style>
